import { styled, Theme } from '@nexelem/deprecated-theme';

export const Divider = styled('div')(({ theme }) => {
  const typedTheme = theme as Theme;
  return {
    width: '1px',
    backgroundColor: typedTheme.palette.getColor(typedTheme.client.richTextField.divider.borderColor),
    margin: '0 4px',
    height: '60%',
    alignSelf: 'center',
  };
});

Divider.displayName = 'Divider';
